import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { AuthProvider } from './auth/AuthContext'
import { GateProvider } from './safety/GateContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import { I18nProvider } from './lib/I18nProvider'
import { initTheme } from './lib/theme'
// Registers the service worker at module load. The banner that surfaces an
// update renders inside PhoneFrame, because a banner outside the column adds to
// its height and pushes the tab bar off screen (SUAP-0106 review).
import './lib/sw'
import './index.css'

const container = document.getElementById('root')
if (container === null) {
  throw new Error('#root is missing from index.html')
}

// Before createRoot, not in an effect: the theme has to be on the document for
// the first paint, or the app flashes light and then flips (SUAP-0102).
initTheme()

createRoot(container).render(
  <StrictMode>
    {/* The boundary wraps the router, not the other way round: a render error
        inside a route must not take out the shell with a white screen. */}
    <ErrorBoundary>
      {/* Inside the boundary, outside the router: the locale belongs to the whole
          app, and the boundary must still render if resolving it throws. */}
      <I18nProvider>
        <BrowserRouter>
          {/* Inside the router, because the guards read the location to preserve
              the destination a signed-out user was heading for. Outside App, so
              the session survives a route change rather than remounting with
              it — a provider inside the route tree re-hydrates on every
              navigation, which is one /api/auth/me per tab press. SUAP-0202. */}
          <AuthProvider>
            {/* Inside AuthProvider, because the gate state is per-user and is
                read once the session is known — and cleared when it goes.
                Outside App for the same reason the session is: a provider inside
                the route tree re-fetches on every navigation, which would be one
                /api/health-screen/gates per tab press. SUAP-1202. */}
            <GateProvider>
              <App />
            </GateProvider>
          </AuthProvider>
        </BrowserRouter>
      </I18nProvider>
    </ErrorBoundary>
  </StrictMode>,
)
